import React from 'react';
import { usePushNotifications } from '../hooks/usePushNotifications';
import { Bell } from 'lucide-react';

export const NotificationBanner: React.FC = () => {
    const { permission, subscribe, loading } = usePushNotifications();

    // Do not show if granted (and subscribed) or explicitly denied
    // Also waiting for initial check (isSubscribed defaults false) might cause flash
    // But permission defaults 'default', so it's fine.

    if (permission === 'granted' || permission === 'denied') return null;
    // Note: checking isSubscribed is tricky because it's async check.
    // If permission is 'default', we definitely want to ask.

    return (
        <div className="fixed bottom-4 right-4 bg-teal-900 text-white p-4 flex items-center justify-between gap-4 z-50 max-w-sm rounded-lg shadow-xl border border-teal-700 animate-in slide-in-from-bottom duration-500">
            <div className="flex items-center gap-3">
                <div className="p-2 bg-teal-800 rounded-full">
                    <Bell className="w-5 h-5 text-teal-300" />
                </div>
                <div>
                    <p className="font-semibold text-sm">Activar Alertas</p>
                    <p className="text-xs text-teal-200">Recibe recordatorios de citas al instante.</p>
                </div>
            </div>
            <button
                onClick={subscribe}
                disabled={loading}
                className="bg-teal-100 text-teal-900 px-3 py-1.5 rounded-md text-sm font-medium hover:bg-white transition-colors disabled:opacity-50 whitespace-nowrap"
            >
                {loading ? '...' : 'Activar'}
            </button>
        </div>
    );
};
